import React from 'react';

const Card = ({ children, className = '', onClick, hover = false }) => (
  <div 
    onClick={onClick}
    className={`
      bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700/50 shadow-xl 
      ${onClick || hover ? 'cursor-pointer hover:border-emerald-500/50 transition-all' : ''} 
      ${className}
    `}
  >
    {children}
  </div>
);

export default Card;
